import script from "./consultantDashboardStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./consultantDashboardStatistics.vue?vue&type=script&setup=true&lang=js"

import "./consultantDashboardStatistics.vue?vue&type=style&index=0&id=5c146381&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c146381"]])

export default __exports__